import React from "react";
import styles from "./styles.module.css";

export default React.memo(({style}) => {
  return (
    <div className={styles.container} style={style}>
      <div className={styles.image}/>
      <div className={styles.overlay}/>
      <div className={styles.logo}/>
    </div>
  );
});

